import { ButtonGroup, IconButton } from "@material-ui/core";
import { Edit as EditIcon, Delete as DeleteIcon } from "@material-ui/icons";

const getOptionals = (onItemClick) => {
  if (onItemClick) {
    return [
      {
        content: (item) => (
          <ButtonGroup variant="outlined" size="small">
            <IconButton
              aria-label="Edit"
              color="secondary"
              onClick={() => onItemClick(item, "edit")}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              aria-label="Edit"
              color="secondary"
              onClick={() => onItemClick(item, "del")}
            >
              <DeleteIcon />
            </IconButton>
          </ButtonGroup>
        ),
        label: "Actions",
      },
    ];
  }
  return [
    {
      path: "amountSpent",
      label: "Amount spent",
    },
  ];
};
export const itemsColumns = (onItemClick) => [
  {
    path: "name",
    label: "Name",
  },
  {
    path: "amount",
    label: "Amount",
  },
  {
    label: "Recurring?",
    content: (item) => (item.isRecurring ? "Yes" : "No"),
  },
  ...getOptionals(onItemClick),
];
